import type { FC } from 'react';
import { CheckCircleOutline } from '@eqi-investimentos/icons/web';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { Thumb } from '@/components/elements/Thumb';
import {
  EDIT_PROFILE_INFO_DRAWER_IDS,
  PERSONAL_INFO_DRAWER_ID,
} from '../utils';
import { getLogoByTheme } from '@/utils/assets';

export const SuccessMessage: FC<SuccessMessageProps> = ({ resetFlow }) => {
  const t = useT();

  const closeAllDrawersAndReset = () => {
    resetFlow();
    profileDrawers.forEach((id) => {
      window.dispatchEvent(new CustomEvent(`close-chakra-modal-${id}`));
    });
  };

  return (
    <Flex flexDir="column" gap="5xl" pt="3xl">
      <Thumb
        src={getLogoByTheme()}
        width={72}
        height={24}
        full
        fit="contain"
        alt="Logo EQI+"
      />
      <Flex gap="xl" flexDir="column">
        <Flex gap="xs" alignItems="center">
          <CheckCircleOutline boxSize="2rem" color="content.brand" />
          <Text size="h6" fontWeight="medium">
            {t('drawers.personalInfo.success.header')}
          </Text>
        </Flex>
        <Text size="xl">{t('drawers.personalInfo.success.description')}</Text>
        <Button onClick={closeAllDrawersAndReset}>
          {t('attributes.close')}
        </Button>
      </Flex>
    </Flex>
  );
};

const profileDrawers = [
  PERSONAL_INFO_DRAWER_ID,
  ...Object.values(EDIT_PROFILE_INFO_DRAWER_IDS),
];

export type SuccessMessageProps = {
  resetFlow: () => void;
};
